<template>
  <transition name='modal'>
    <div class='modalcon'>
      <div class='modal-mask'>
        <div class='modal-wrapper'>
          <div class='modal-container' @click.stop>
            <span class='closebtn' @click='setPopup'>
              <i class='fa fa-close' aria-hidden='true'></i>
            </span>
            <div class='clearfix'></div>
            <div class='mbox'>
             <div class="modal-body mb0">
              <div class="fbold title">
                {{ processData && processData.length ? processData[0] : '' }}
              </div>
              <ul style="padding-left: 16px;">
                <li v-for="(item, index) in processData" :key="index" v-if="index !== 0">
                  {{ item }}
                </li>
              </ul>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
var $ = require('jquery')
window.jQuery = $

export default {
  props: ['setPopup', 'processData'],
  created () {
    $('body').addClass('_freeze')
  },
  beforeDestroy () {
    $('body').removeClass('_freeze')
  }
}

</script>

<style lang='css' scoped>
.title {
  color: #2bb49f;
  font-size: 20px;
  margin-bottom: 5px;
}
.modal-header {
  border: none;
}

.notify-logo {
  margin: 0 auto;
  height: 120px;
  margin-top: -74px;
}

.closebtn {
  background: #2bb49f;
  border-radius: 24px;
  padding: 2px 7px;
  color: #fff;
  position: absolute;
  margin-top: -12px;
  right: -12px;
  cursor: pointer;
}

.closebtn:hover {
  background: #1a917f;
}

.modalcon {
  position: fixed;
  display: block;
  left: 0;
  z-index: 9998;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
  transition: opacity 0.3s ease;
}

.modal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 530px;
  margin: 0px auto;
  transition: all 0.3s ease;
  position: relative;
}

.mbox {
  border: 3px solid #2bb49f;
  background: #fff;
  padding: 10px;
  padding-bottom: 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  height: inherit;
  letter-spacing: 0px;
  text-align: left;
}

.modal-header,
.modal-body {
  padding: 5px 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-enter .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 768px) {
  .modal-container {
    width: 92%;
  }
}

@media screen and (max-width: 480px) {
  .mbox {
    padding: 0;
    height: inherit;
  }
  .notify-logo {
    height: 84px;
    margin-top: -40px;
  }
}
</style>



// WEBPACK FOOTER //
// tssHelpDetails.vue?10b98fe1